
/**
 * 採番ルール
 * MSG_(3桁の整数)
 * 2 認証
 * 3 GraphQL
 * 5 業務API
 * 9 例外
 */

export default {
  MSG_201: () => '認証処理に失敗しました。',
  MSG_202: () => 'パラメータ不正です。',
  MSG_203: () => 'ID、パスワードを確認して下さい。',
  MSG_204: () => 'セッションタイムアウト',
  MSG_205: () => 'コンソール接続が許可されていないアカウントです。',
  MSG_206: () => 'SSO認証に失敗しました。',

  MSG_301: () => 'データの取得に失敗しました。',
  MSG_302: () => 'サイトマスタの取得に失敗しました。',
  MSG_303: () => 'サービス・サイト設定の取得に失敗しました。',
  MSG_304: () => 'アカウント情報の取得に失敗しました。',
  MSG_305: ({ limit, count } = {}) => `検索結果が${limit}件を超えました。\n条件を絞って検索してください。\n(総検索結果：${count}件)`,
  MSG_306: () => '全ての検索結果を表示することができません。\n条件を絞って検索してください。',
  MSG_307: () => '条件設定の取得に失敗しました。',

  MSG_501: () => '注文情報更新に失敗しました。',
  MSG_502: () => '保存処理で予期せぬエラーが発生しました。',
  MSG_503: () => '出荷指図登録に失敗しました。',
  MSG_504: () => '決済情報の更新に失敗しました。',
  MSG_505: () => '注文取消に失敗しました。',
  MSG_506: () => 'メモの登録に失敗しました。',
  MSG_507: () => 'メモの削除に失敗しました。',
  MSG_508: ({ method } = {}) => `メモの${method}に失敗しました。`,
  MSG_509: () => 'アカウントの登録に失敗しました。',
  MSG_510: () => 'アカウントの更新に失敗しました。',
  MSG_511: () => '権限ロールの登録に失敗しました。',
  MSG_512: () => '権限ロールの更新に失敗しました。',
  MSG_513: () => 'サイトロールの登録に失敗しました。',
  MSG_514: () => 'サイトロールの更新に失敗しました。',
  MSG_515: () => 'アカウントの削除に失敗しました。',
  MSG_516: () => 'サイトロールの削除に失敗しました。',
  MSG_517: () => '権限ロールの削除に失敗しました。',
  MSG_518: () => 'パスワードの更新に失敗しました。',
  MSG_519: ({ reason } = {}) => reason ? `${reason}のため支払処理の更新に失敗しました。` : '支払処理の更新に失敗しました。',
  MSG_520: () => '現在のパスワードが一致しません。',
  MSG_521: () => '注文が更新されている可能性があります。',
  MSG_522: () => '権限の強さが同等以上のアカウントに対して、操作は行えません。',
  MSG_523: () => '権限の強さが同等以上のアカウントが使用しているため、操作できません。',
  MSG_524: () => '使用しているアカウントがあるため、削除できません。',
  MSG_525: () => '同じアカウントが既に存在しています。',
  MSG_526: () => '注文CSVダウンロードに失敗しました。',
  MSG_527: () => 'ダウンロードに失敗しました。',
  MSG_528: () => 'アカウントが更新されている可能性があります。',
  MSG_529: () => 'サイトロールが更新されている可能性があります。',
  MSG_530: () => '権限ロールが更新されている可能性があります。',
  MSG_531: () => 'アラート設定の登録に失敗しました。',
  MSG_532: () => 'アラート設定の更新に失敗しました。',
  MSG_533: () => 'アラート設定の削除に失敗しました。',
  MSG_534: () => '商品が更新されている可能性があります。',
  MSG_535: () => '商品の登録に失敗しました。',
  MSG_536: () => '商品の更新に失敗しました。',
  MSG_537: () => '品番コードが他の商品と重複しています。',
  MSG_538: () => 'SKUコードが他の商品と重複しています。',
  MSG_539: () => 'メール送信に失敗しました。',

  MSG_540: () => '臨時出荷指図依頼に失敗しました。',

  MSG_541: () => 'カラーの更新に失敗しました。',
  MSG_542: () => 'カラーグループの更新に失敗しました。',

  MSG_543: () => 'バンドルの構成品として使用されているため、削除できません。',
  MSG_544: () => '受注済みの商品のため削除できません。',

  MSG_545: () => 'サイズの更新に失敗しました。',
  MSG_546: () => 'サイズグループの更新に失敗しました。',

  MSG_547: () => '構成品マスタの更新に失敗しました。',
  MSG_548: () => '配送休業日の更新に失敗しました。',
  MSG_549: () => '表示項目設定の削除に失敗しました。',

  MSG_550: () => 'メールテンプレートの登録に失敗しました。',
  MSG_551: () => 'メールテンプレートの更新に失敗しました。',
  MSG_552: () => 'メールテンプレートの削除に失敗しました。',

  MSG_553: () => 'O-Plux API の実行に失敗しました。',

  MSG_554: () => '調整ポイントの登録に失敗しました。',

  MSG_901: () => '予期せぬエラー',
  MSG_902: () => '予期せぬエラーが発生しました。'
}



// WEBPACK FOOTER //
// ./src/utils/message.js